import { render, staticRenderFns } from "./follow_my.vue?vue&type=template&id=1afe4d8a&"
import script from "./follow_my.vue?vue&type=script&lang=js&"
export * from "./follow_my.vue?vue&type=script&lang=js&"
import style0 from "./follow_my.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports